// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__eeZpu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 179
// module chunks = 1